<div class="header-label">
  <h2>API Request/Response Info</h2>
</div>

<div class="filter-row">

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>Claim Key</mat-label>
    <input matInput [(ngModel)]="filter.claimKey" placeholder="Type claim key...">
  </mat-form-field>

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>API Method</mat-label>
    <mat-select [(ngModel)]="filter.apiMethod">
      <mat-option value="">Select API method</mat-option>
      <mat-option *ngFor="let method of apiMethods" [value]="method">{{ method }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>Request Date</mat-label>
    <input matInput [matDatepicker]="requestDatePicker" [(ngModel)]="filter.requestDate" placeholder="Select request date">
    <mat-datepicker-toggle matIconSuffix [for]="requestDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #requestDatePicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>Requested By</mat-label>
    <input matInput [(ngModel)]="filter.requestedBy" placeholder="Type requested by...">
  </mat-form-field>

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>Status</mat-label>
    <input
      matInput
      type="text"
      [formControl]="statusControl"
      [matAutocomplete]="statusAuto"
      #statusTrigger="matAutocompleteTrigger"
      placeholder="Search status" />
    <app-autocomplete-suffix-actions
      matSuffix
      [showClear]="statusControl.value !== ''"
      [panelOpen]="statusTrigger.panelOpen"
      (clearClicked)="clearSelectedStatus($event)"
      (toggleClicked)="openOrClosePanel($event, statusTrigger)">
    </app-autocomplete-suffix-actions>
    <mat-autocomplete
      #statusAuto="matAutocomplete"
      [clearStaleSelectionOnOpen]="statusControl.value"
      [displayWith]="displayOption">
      <mat-option *ngFor="let status of filteredStatuses$ | async" [value]="status">
        {{ status }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <div class="filter-button-wrap">
    <button mat-flat-button color="primary" (click)="onFilter()">
      Filter
    </button>
  </div>

</div>

<div *ngIf="errorMessage" class="api-error-banner">
  {{ errorMessage }}
</div>

<div class="table-loader" *ngIf="loading">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>

<div class="table-wrapper" [class.loading]="loading">

  <table mat-table [dataSource]="dataSource" matSort [matSortActive]="sortBy" [matSortDirection]="sortDir">

    <ng-container matColumnDef="claimKey">
      <th mat-header-cell *matHeaderCellDef>Claim Key</th>
      <td mat-cell *matCellDef="let row">{{ row.claimKey }}</td>
    </ng-container>

    <ng-container matColumnDef="apiMethod">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="apiMethod">API Method</th>
      <td mat-cell *matCellDef="let row">{{ row.apiMethod }}</td>
    </ng-container>

    <ng-container matColumnDef="requestDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="requestDate">Request Date</th>
      <td mat-cell *matCellDef="let row">{{ row.requestDate }}</td>
    </ng-container>

    <ng-container matColumnDef="requestedBy">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="requestedBy">Requested By</th>
      <td mat-cell *matCellDef="let row">{{ row.requestedBy }}</td>
    </ng-container>

    <ng-container matColumnDef="responseDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="responseDate">Response Date</th>
      <td mat-cell *matCellDef="let row">{{ row.responseDate }}</td>
    </ng-container>

    <ng-container matColumnDef="RequestFile">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="RequestFile">Request File</th>
      <td mat-cell *matCellDef="let row">{{ row.RequestFile }}</td>
    </ng-container>

    <ng-container matColumnDef="ResponseFile">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="ResponseFile">Response File</th>
      <td mat-cell *matCellDef="let row">{{ row.ResponseFile }}</td>
    </ng-container>

    <ng-container matColumnDef="responseTime">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="responseTime">Response Time</th>
      <td mat-cell *matCellDef="let row">{{ row.responseTime }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</th>
      <td mat-cell *matCellDef="let row">{{ row.status }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  </table>

  <div *ngIf="dataSource.data.length === 0" class="no-results-message">
    No records found
  </div>

</div>

<mat-paginator
  [length]="totalCount"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="[10, 20, 50]"
  (page)="onPageChange($event)"
  showFirstLastButtons>
</mat-paginator>
